<template>
  <div>
    <div class="headLine">
      <div class="leftBlock">
        <div class="back-bt" v-if="params.backUrl">
          <a :href="params.backUrl"></a>
        </div>
        <div
            class="show-menu"
            v-if="$store.state.global.screenWidth < 1200"
        >
          <span class="closed-menu-control" v-for="n in 3" :key="n"></span>
          <img class="opened-menu-control" src="/ua-uk/local/templates/main/images/menu-ico/close.svg" alt=""/>
        </div>
        <div class="rootMenuKatalog" v-bind:class="{checkoutPage: !params.showSmollBasket}" @click="showDmenu()" v-else>
          <button class="burger">
            <span></span>
            <span></span>
            <span></span>
          </button>
          <span class="menu-title">{{ params.rootItem }}</span>
        </div>
        <div class="logo">
          <a :href="params.logo.link" v-html="params.logo.picture"></a>
        </div>
        <div class="helpPhone" v-if="params.helpPhone.link">
          <a :href="params.helpPhone.link">{{ params.helpPhone.title }}</a>
        </div>
      </div>
<!--      <div class="middleBlock" v-if="$store.state.global.screenWidth > 992">-->
<!--        <select class="header-langs">-->
<!--          <option v-for="lang in getLangItems()" :selected="lang.active" :value="lang.link">{{lang.title}}</option>-->
<!--        </select>-->
<!--      </div>-->
      <div class="rightBlock" v-bind:class="{checkoutPage: !params.showSmollBasket}">
        <div class="mobile-search" v-if="$store.state.global.screenWidth < 491">
          <a href="#" @click="mobileSearch()" id="searchToggleBtn">
            <img src="/ua-uk/local/templates/main/images/menu-ico/search.svg" alt="search"/>
          </a>
        </div>
        <div class="search" v-if="$store.state.global.screenWidth > 1200">
          <smollSearch :data="params.search"/>
        </div>
        <a :href="params.shopsLink" class="location-link" v-if="$store.state.global.screenWidth > 1200"></a>
        <div class="profile">
          <a :href="params.personalLink">
            <img class="personal-menu-ico" src="/ua-uk/local/templates/main/images/menu-ico/personal.svg" alt="profile"/>
          </a>
        </div>
        <div class="favs">
          <a class="fav" :class="{'is-active': params.wishlistCount > 0 }" :href="params.favlLink"><span><i></i></span></a>
        </div>
        <div class="mini-bask" v-if="params.showSmollBasket && false">
          <smollBasket class="smollBasket"></smollBasket>
        </div>
        <div class="go-back">
          <a href="javascript:history.back()">{{ params.messages.backUrlTitle }}</a>
        </div>
      </div>
      <DesktopMenu v-if="$store.state.global.screenWidth > 1200"
                   :menu-items="getMobileItems"
                   @set-menu-key="_setActivePunct"
                   :active-item="hoveredItem"
                   :opened="showDeskMenu"
      />
    </div>
    <div class="navs" v-if="$store.state.global.screenWidth < 1200">
      <div class="menu-hide-top">
        <div
            class="menu-top-home"
            v-if="$store.state.global.screenWidth < 1200"
        >
          <a :href="params.logo.link">
            <i>
              <img src="/ua-uk/local/templates/main/images/menu-ico/home.svg" alt="search"/>
            </i>
            <span>{{ params.messages.homePageTitle }}</span>
          </a>
        </div>
        <div class="menu-link mobile">
          <ul>
            <li>
              <template v-for="(lang, i) in params.langs">
                <a
                    class="lang_item"
                    :class="lang.active ? 'active' : ''"
                    :href="lang.link"
                >{{ lang.text }}</a
                >
                <i v-if="i < params.langs.length - 1">/</i>
              </template>
            </li>
          </ul>
        </div>
      </div>
      <div class="menu-hide-search">
        <form autocomplete="off" method="get" :action="params.searchLink">
          <input
              type="text"
              name="q"
              :placeholder="params.messages.searchPlaceholder + '...'"
          />
          <button type="submit"></button>
        </form>
      </div>
      <div class="nav-scroll">
        <MobileMenu
            :items="getMobileItems"
            v-if="$store.state.global.screenWidth < 1200"
        />
      </div>
      <div
          class="salir"
          v-if="params.loguotLink && $store.state.global.screenWidth < 1200"
      >
        <a href="params.loguotLink" class="js-logout">{{
            params.messages.exit
          }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import smollBasket from "./checkout/smollBasket.vue";
import SmollSearch from "./smollSearch.vue";
import SmollBasket from "./checkout/smollBasket.vue";
import NavigationBlock from "./menu/MenuNavigationItem.vue";
import DesktopMenu from "./menu/DesktopMenu.vue";
import MobileMenu from "./menu/MobileMenu.vue";

export default {
  name: "top_menu",
  components: {MobileMenu, DesktopMenu, NavigationBlock, SmollBasket, SmollSearch},
  selector: ".top_menu",
  comments: [smollBasket],
  props: {params: Object},
  data() {
    return {
      items: {},
      hoveredItem: -1,
      activeLink: '',
      showDeskMenu: false,
    };
  },
  created() {
    this.getMobileItems = this._getMobileItems()
  },
  methods: {
    getLangItems() {
      return [
        {
          active: !!this.params.extMenu.langUa.active,
          link: this.params.extMenu.langUa.link,
          title: this.params.extMenu.langUa.title
        },
        {
          active: !!this.params.extMenu.langRu.active,
          link: this.params.extMenu.langRu.link,
          title: this.params.extMenu.langRu.title
        }
      ];
    },
    _getMobileItems() {
      let res = this.params.items;
      res.sort((a, b) => (+a.mobileSort > +b.mobileSort ? 1 : -1));
      for (let index in res) {
        if (res[index].children != undefined) {
          res[index].children.sort((a, b) => (+a.mobileSort > +b.mobileSort ? 1 : -1));
        }
      }
      return res;
    },
    mobileSearch() {
      $('#mobileSearchBlock').toggle()
    },
    showDmenu() {
      this.showDeskMenu = !this.showDeskMenu;
    },

    _setActivePunct(key, link = '') {
      this.hoveredItem = key;
      if(link) {
        this.activeLink = link;
      }
    },
    handleClickOutside(event) {
      const searchBox = document.getElementById('mobileSearchBlock');
      const toggleBtn = document.getElementById('searchToggleBtn');

      if (
          searchBox &&
          !searchBox.contains(event.target) &&
          toggleBtn &&
          !toggleBtn.contains(event.target)
      ) {
        $('#mobileSearchBlock').hide()
      }
    }

  },
  mounted() {
    $('select.header-langs').change(function () {
      window.location.href = $(this).val();
    });
    window.addEventListener("click", (target) => {
      if (target?.target?.className != 'rootMenuKatalog') {
        if (!target.target.closest(".desktopMenu") && this.showDeskMenu) {
          this.showDeskMenu = false;
        }
      }
    });
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>
<style lang="scss">
.burger {
  width: 24px;
  height: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  pointer-events: none;
}
.burger span {
  display: block;
  height: 2px;
  width: 100%;
  background-color: #000;
  border-radius: 2px;
  transition: 0.3s;
}
.menu-title {
  margin-top: 3px;
  font-size: 15px;
  pointer-events: none;
}
.helpPhone {
  margin-left: 30px;
}
.header-langs,
.header-langs.opened {
  .jq-selectbox__select {
    padding-right: 18px;
    border: none !important;
  }
  .jq-selectbox__select-text {
    font-size: 14px;
    font-weight: bold;
    width: auto !important;
  }
  .jq-selectbox__trigger {
    border-left: none;
  }
  .jq-selectbox__trigger-arrow {
    left: 73%;
  }
}
.location-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: #000;
  font-size: 14px;
  margin-left: 20px;
}

/* Иконка */
.location-link::before {
  content: "";
  display: inline-block;
  width: 25px;
  height: 25px;
  background: no-repeat center/contain url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" stroke="%23000" stroke-width="3" fill="none" viewBox="0 0 50 50"><path d="M25 42.5l-.8-.9C23.7 41.1 12 27.3 12 19c0-7.2 5.8-13 13-13s13 5.8 13 13c0 8.3-11.7 22.1-12.2 22.7l-.8.8z"/><circle cx="25" cy="19" r="5"/></svg>');
}


.review-count span {
  background: #3c3d41;
  padding: 3px 6px;
  border-radius: 10px;
  color: #fff;
}

.subLevelMenu {
  &__wrapper {
    position: relative;
    border-bottom: 2px solid #F7F7F7;
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    grid-auto-rows: min-content;
    margin: 0 23px;

    &:empty {
      display: none
    }

    &::after {
      content: "";
      display: block;
      width: 100%;
      height: 2px;
      background-color: #F7F7F7;
      bottom: 0;
      position: absolute;
    }
  }


  &__block {
    display: flex;
    flex-direction: column;
    padding: 17px 20px 17px 0;
    border-bottom: 2px solid #F7F7F7;
  }
}

.rootItem {
  display: flex;

  &:after {
    transition: .3s linear border-color;
  }

  &.active {
    &:after {
      border-color: #D63976 !important;
    }

    a {
      &:before {
        width: 100%;
        left: 0;
      }
    }
  }

  span {
    display: flex;
    margin-right: 6px;
    width: 18px;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  a {
    display: flex;
    position: relative;
    overflow: hidden;

    &:before {
      content: '';
      position: absolute;
      height: 2px;
      background-color: #D63976;
      width: 100%;
      top: calc(100% - 2px);
      left: -100%;
      transition: .3s linear left;
    }
  }
}

.subItem {
  display: inline-block;

  &:not(.child) {
    a {
      display: inline-block;
      position: relative;
      overflow: hidden;
      padding-bottom: 2px;

      &:before {
        content: '';
        position: absolute;
        height: 2px;
        background-color: #D63976;
        width: 100%;
        top: calc(100% - 2px);
        left: -100%;
        transition: .3s linear left;
      }

      &:hover {
        &:before {
          width: 100%;
          left: 0;
        }
      }
    }
  }
}
</style>
<style>
.rootItem a {
  font-family: "TOUS", sans-serif;
  font-size: 12px;
  color: #010101;
  font-weight: bold;
}

.leftFixBlock {
  width: 280px;
}

.subLevelMenu a {
  /*  font-family: "TOUS", sans-serif;
    font-weight: 400;*/

  font-family: "Roboto", sans-serif;
  font-weight: 500;

  color: #010101;
  font-size: 16px;
  letter-spacing: normal;
}

.subLevelMenu .subItem:not(.child) a {
  font-family: "TOUS", sans-serif;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
}

.subLevelMenu .subItem.child a {
  font-size: 12px;
  line-height: 13px;
  /*font-family: "TOUS", sans-serif;*/
  font-weight: normal;
}

.subLevelMenu a .imgWraper svg g {
  fill: #7b7c7e;
}

.imgWraper svg {
  width: 100%;
  height: 100%;
}

.subLevelMenu a:hover .imgWraper svg g {
  fill: #000;
}
</style>
<style scoped>
.imgWraper {
  display: inline-block;
  width: 50px;
  height: 50px;
  vertical-align: middle;
}

.rootMenuKatalog {
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  color: #3c3d41;
  letter-spacing: 2px;
  font-family: "TOUS", sans-serif;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  margin-right: 30px;
  margin-top: 3px;
}

.rootMenuKatalog:hover {
  color: #000;
}

.logo {
  padding-top: 0;
}

.headLine {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0px;
  position: relative;
}

.headLine .leftBlock,
.headLine .rightBlock {
  display: flex;
  align-items: center;
}

.headLine .rightBlock {
}

.headLine .rightBlock > div {
  margin-left: 15px;
}

.middleBlock {
  display: flex;
  align-items: center;
}

.middleBlock a {
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  color: #cccccc;
  letter-spacing: 2px;
  font-family: "TOUS", sans-serif;
}

.middleBlock a.active {
  color: #3c3d41;
}

.middleBlock i {
  padding: 0 7px 0 7px;
  font-size: 9px;
  margin-top: -3px;
}

.headLine div.leftBlock > div.checkoutPage,
.headLine div.rightBlock.checkoutPage > div:not(.go-back) {
  display: none;
}

.ext-menu-links a,
.helpPhone a,
.helpText a {
  font-weight: 700;
  font-size: 10px;
  text-transform: uppercase;
  color: #3c3d41;
  display: inline-block;
  vertical-align: middle;
}
.helpPhone a {
  font-size: 20px;
}

.ext-menu-links a {
  margin-top: 3px;
  float: right;
}

.ext-menu-links a:not(:last-of-type) {
  margin-left: 15px;
}

.ext-menu-links a:hover {
  color: #000;
}

/*
.helpPhone a:before {
  content: "";
  background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE2IDE2Ij48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0xMSAxYTEgMSAwIDAgMSAxIDF2MTJhMSAxIDAgMCAxLTEgMUg1YTEgMSAwIDAgMS0xLTFWMmExIDEgMCAwIDEgMS0xaDZ6TTUgMGEyIDIgMCAwIDAtMiAydjEyYTIgMiAwIDAgMCAyIDJoNmEyIDIgMCAwIDAgMi0yVjJhMiAyIDAgMCAwLTItMkg1eiIvPjxwYXRoIGQ9Ik04IDE0YTEgMSAwIDEgMCAwLTJhMSAxIDAgMCAwIDAgeiIvPjwvZz48L3N2Zz4=") left center no-repeat;
  width: 18px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  margin-top: -3px;
}
*/

.lang_item {
  text-transform: uppercase;
}

.favs,
.profile{
  position: relative;
}
.profile a {
  padding-left: 20px;
}

.profile::before,
.favs::before {
  content: "";
  width: 1px;
  height: 12px;
  margin-top: -5px;
  left: 0;
  position: absolute;
  top: 50%;
  background-color: #7b7c7e;
}

.favs::after {
  content: "";
  width: 1px;
  height: 12px;
  margin-top: -5px;
  right: 0;
  position: absolute;
  top: 50%;
  background-color: #7b7c7e;
}

.favs > a {
  padding: 1px 20px 0;
  font-size: 10px;
  font-weight: bold;
  color: #3c3d41;
  float: left;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  height: 26px;
  align-content: center;
  -ms-align-items: center;
  align-items: center;
}

.favs > a > span {
  display: inline-block;
  background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOHB4IiBoZWlnaHQ9IjE4cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNNyAzQzQuMjM5IDMgMiA1LjIxNiAyIDcuOTVjMCAyLjIwNy44NzUgNy40NDUgOS40ODggMTIuNzRhLjk4NS45ODUgMCAwIDAgMS4wMjQgMEMyMS4xMjUgMTUuMzk1IDIyIDEwLjE1NyAyMiA3Ljk1QzIyIDUuMjE2IDE5Ljc2MSAzIDE3IDNzLTUgMy01IDNzLTIuMjM5LTMtNS0zWiIvPjwvc3ZnPg==") 0 0 no-repeat;
  width: 18px;
  height: 18px;
}

.favs > a.is-active > span {
  background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOHB4IiBoZWlnaHQ9IjE4cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0iI2YyYzdjMSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNNyAzQzQuMjM5IDMgMiA1LjIxNiAyIDcuOTVjMCAyLjIwNy44NzUgNy40NDUgOS40ODggMTIuNzRhLjk4NS45ODUgMCAwIDAgMS4wMjQgMEMyMS4xMjUgMTUuMzk1IDIyIDEwLjE1NyAyMiA3Ljk1QzIyIDUuMjE2IDE5Ljc2MSAzIDE3IDNzLTUgMy01IDNzLTIuMjM5LTMtNS0zWiIvPjwvc3ZnPg==") 0 0 no-repeat;
}

.go-back a {
  color: #959594;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
}

.back-bt {
  float: none;
}

.personal-menu-ico {
  width:23px;
}

@media (max-width: 920px) {
  .personal-menu-ico{
    height: 27px;
    width: auto;
  }
  .profile {
    svg {
      width: 30px;
      height: 30px;
    }
    a {
      padding-left: 0;
    }
    &::before {
      display: none;
    }
  }

  .favs > a > span {
    background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNXB4IiBoZWlnaHQ9IjI1cHgiIHZpZXdCb3g9IjAgMCAyNSAyNSI+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNNyAzQzQuMjM5IDMgMiA1LjIxNiAyIDcuOTVjMCAyLjIwNy44NzUgNy40NDUgOS40ODggMTIuNzRhLjk4NS45ODUgMCAwIDAgMS4wMjQgMEMyMS4xMjUgMTUuMzk1IDIyIDEwLjE1NyAyMiA3Ljk1QzIyIDUuMjE2IDE5Ljc2MSAzIDE3IDNzLTUgMy01IDNzLTIuMjM5LTMtNS0zWiIvPjwvc3ZnPg==") 0 0 no-repeat;
    width: 23px;
    height: 24px;
    margin-top: 2px;
  }

  .favs::before, .favs::after {
    display: none;
  }

  .favs > a {
    padding: 0 0px;

    &.is-active > span {
      background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSI+PHBhdGggZmlsbD0iI2YyYzdjMSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNNyAzQzQuMjM5IDMgMiA1LjIxNiAyIDcuOTVjMCAyLjIwNy44NzUgNy40NDUgOS40ODggMTIuNzRhLjk4NS45ODUgMCAwIDAgMS4wMjQgMEMyMS4xMjUgMTUuMzk1IDIyIDEwLjE1NyAyMiA3Ljk1IDIyIDUuMjE2IDE5Ljc2MSAzIDE3IDNzLTUgMy01IDMtMi4yMzktMy01LTNaIi8+PC9zdmc+") 0 0 no-repeat;
      /*background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSI+PHBhdGggZmlsbD0iI2YyYzdjMSIgc3Ryb2tlPSJub25lIiBkPSJNNyAzQzQuMjM5IDMgMiA1LjIxNiAyIDcuOTVjMCAyLjIwNy44NzUgNy40NDUgOS40ODggMTIuNzRhLjk4NS45ODUgMCAwIDAgMS4wMjQgMEMyMS4xMjUgMTUuMzk1IDIyIDEwLjE1NyAyMiA3Ljk1IDIyIDUuMjE2IDE5Ljc2MSAzIDE3IDNzLTUgMy01IDMtMi4yMzktMy01LTNaIi8+PC9zdmc+") 0 0 no-repeat;*/
    }
  }
}

@media (max-width: 790px) {
    .logo {
    padding-top: 4px;
  }
  .helpText {
    display: none;
  }
  .headLine {
    padding: 10px 0;
  }
  .mobile-search img{
    width: 22px;
    margin-top: 2px;
  }
}

@media (max-width: 490px) {
  .helpPhone {
    display: none;
  }
}

</style>